<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title" style="margin-top: 10px">Bonuslar</h3>

        <div
          class="card-tools"
          v-if="auth.CustomerBonus != null && auth.CustomerBonus.isWrite"
        >
          <div class="row">
            <div class="col">
              <select
                v-model="type"
                @change="typeChange"
                class="form-control form-control-sm"
              >
                <option v-for="data in types" :key="data.id" :value="data.id">
                  {{ data.name }}
                </option>
              </select>
            </div>
            <div class="col">
              <select
                v-model="group"
                @change="groupChange"
                class="form-control form-control-sm"
                :disabled="type == -1"
              >
                <option :value="-1">Grup Seçiniz</option>

                <option v-for="data in groups" :key="data.id" :value="data.id">
                  {{ data.name }}
                </option>
              </select>
            </div>
            <div class="col">
              <select
                v-model="bonus"
                class="form-control form-control-sm"
                :disabled="group == -1"
              >
                <option :value="-1">Bonus Seçiniz</option>
                <option v-for="data in bonuses" :key="data.id" :value="data.id">
                  {{ data.name }}
                </option>
              </select>
            </div>
            <div class="col">
              <button class="btn btn-primary btn-sm" @click="addBonus" :disabled="bonus<=0">
                Müşteriye Ekle
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body table-responsive" style="height: 600px">
        <div class="overlay-wrapper">
          <div class="overlay" v-if="overlay">
            <i class="fas fa-3x fa-spinner fa-spin"></i>
          </div>
          <div class="row">
            <div class="col-2" v-for="data in datas" :key="data.id">
              <div
                class="card card-outline"
                :class="{
                  'card-primary': !data.type,
                  'card-secondary': data.type,
                }"
              >
                <img
                  class="card-img-top"
                  :src="data.image"
                  alt="Card image cap"
                />
                <div class="card-body">
                  <h5 class="card-title">{{ data.name }}</h5>

                  <p
                    class="card-text small"
                    style="
                      height: 18px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    "
                    :title="data.description"
                  >
                    <b>Açıklama: </b>{{ data.description }}
                  </p>
                  <p
                    class="card-text small"
                    style="
                      height: 18px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    "
                    :title="data.subname + ' ' + data.descname"
                  >
                    {{ data.subname }} {{ data.descname }}
                  </p>

                  <button
                    class="btn btn-primary btn-sm"
                    @click="request(data.id)"
                    v-if="
                      auth.BonusRequestAdd != null &&
                      auth.BonusRequestAdd.isWrite
                    "
                  >
                    Talep Et
                  </button>
                  <button
                    class="btn btn-danger float-right btn-sm"
                    @click="discard(data.id)"
                    v-if="
                      data.vip &&
                      auth.CustomerBonus != null &&
                      auth.CustomerBonus.isWrite
                    "
                  >
                    Çıkar
                  </button>
                </div>
                <div class="card-footer">
                  <small class="text-muted">{{ data.message }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["customer"],
  data() {
    return {
      auth: this.$store.getters.getModules,
      datas: [],
      search: "",
      overlay: false,
      type: -1,
      types: [
        { id: -1, name: "Tip Seçiniz" },
        { id: false, name: "Bonus" },
        { id: true, name: "Freebet" },
      ],
      group: -1,
      groups: [],
      bonus: -1,
      bonuses: [],
    };
  },

  methods: {
    getDatas() {
      this.overlay = true;
      this.$http
        .get("Bonus/ListCustomerBonus/" + this.customer.code)
        .then((response) => {
          this.datas = response.data;
          this.overlay = false;
        });
    },
    getBonuses() {
      this.overlay = true;
      this.$http.get("Bonus/ListBonuses/" + this.group).then((response) => {
        this.bonuses = response.data;
        this.overlay = false;
      });
    },
    getGroups() {
      this.overlay = true;
      this.$http
        .get("Bonus/ListBonusGroups/?type=" + this.type)
        .then((response) => {
          this.groups = response.data;
          this.overlay = false;
        });
    },
    typeChange() {
      this.group = -1;
      this.bonus = -1;
      if (this.type == -1) return;

      this.getGroups();
    },
    groupChange() {
      this.bonus = -1;
      if (this.group == -1) return;

      this.getBonuses();
    },
    addBonus() {
      this.overlay = true;
      this.$http
        .post("Bonus/AddCustomerBonus/", {
          bonus: this.bonus,
          customer: this.customer.id,
        })
        .then(
          (response) => {
            toastr.success("Bonus başarıyla eklendi.");
            this.overlay = false;
            this.type = -1;
            this.group = -1;
            this.bonus = -1;
            this.getDatas();
          },
          (err) => {
            toastr.error(
              "İşlem sırasında bir hata oluştu! Lütfen tekrar deneyiniz."
            );
            this.overlay = false;
          }
        );
    },
    discard(id) {
      this.overlay = true;
      this.$http
        .post("Bonus/RemoveCustomerBonus/", {
          bonus: id,
          customer: this.customer.id,
        })
        .then(
          (response) => {
            toastr.success("Bonus başarıyla çıkarıldı.");
            this.overlay = false;
            this.getDatas();
          },
          (err) => {
            toastr.error(
              "İşlem sırasında bir hata oluştu! Lütfen tekrar deneyiniz."
            );
            this.overlay = false;
          }
        );
    },
    request(id) {
      this.overlay = true;
      this.$http
        .post("Bonus/RequestBonus/", { bonus: id, customer: this.customer.id })
        .then(
          (response) => {
            toastr.success("Bonus talebiniz başarıyla alındı.");
            this.overlay = false;
          },
          (err) => {
            toastr.error(
              "İşlem sırasında bir hata oluştu! Lütfen tekrar deneyiniz."
            );
            this.overlay = false;
          }
        );
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Belirtilmemiş";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  computed: {
    filtered() {
      return this.datas.filter((value) => {
        return value.name.toLowerCase().match(this.search.toLowerCase());
      });
    },
  },
  created() {
    this.getDatas();
  },
  watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Customer/CustomerBonus.vue